import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
export class ConditionsWordTask extends ConditionRegistryCategory {
    label = 'WordTask';
    constructor(parent) {
        super(parent);
        super.init();
    }
    wordtask_correct = () => new ConditionRegistryItem({
        label: 'Wordtask ist richtig beantwortet',
        eval: ({ wordTask }) => !!wordTask && wordTask.wordTaskEvaluate.isMainifestedCorrect
    });
    wordtask_wrong = () => new ConditionRegistryItem({
        label: 'Wordtask ist falsch beantwortet',
        eval: ({ wordTask }) => !!wordTask && wordTask.wordTaskEvaluate.isMainifestedWrong
    });
    wordtask_unsure = () => new ConditionRegistryItem({
        label: 'Wordtask ist pending',
        eval: ({ wordTask }) => !!wordTask && wordTask.taskProgress.isTaskPending
    });
    wordtask_complete = () => new ConditionRegistryItem({
        label: 'Wordtask ist komplett',
        eval: ({ wordTask }) => !!wordTask && wordTask.taskProgress.isTaskCompleted
    });
    wordtask_isActive = () => new ConditionRegistryItem({
        label: 'Is Active Word Task',
        eval: ({ wordTask }) => !!wordTask && wordTask.isActiveWordTask
    });
    wordtask_isExpectingNumber = () => new ConditionRegistryItem({
        label: 'isExpectingNumber',
        eval: ({ wordTask }) => !!wordTask && wordTask.wordTaskExpect.isExpectingNumber
    });
    wordtask_hasPrefix = () => new ConditionRegistryItem({
        label: 'Wordtask hat Prefix',
        eval: ({ wordTask }) => !!wordTask && wordTask.ownAspect.prefix.aspectContent.local.hasContent
    });
    wordtask_hasPostfix = () => new ConditionRegistryItem({
        label: 'Wordtask hat Postfix',
        eval: ({ wordTask }) => !!wordTask && wordTask.ownAspect.postfix.aspectContent.local.hasContent
    });
}
